// TheRentPayer brand icon - House with shield
export const NestIcon = ({ className = "", size = 24 }) => (
  <svg 
    viewBox="0 0 24 24" 
    width={size} 
    height={size} 
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Shield outline */}
    <path d="M12 2L3 7v6c0 5.25 3.75 9.75 9 11 5.25-1.25 9-5.75 9-11V7l-9-5z" />
    {/* House inside shield */}
    <path d="M12 8l-4 3.5v4.5h3v-3h2v3h3v-4.5L12 8z" fill="currentColor" fillOpacity="0.2" />
    <path d="M8 11.5L12 8l4 3.5" />
    <path d="M8 11.5v4.5h8v-4.5" />
    <path d="M11 16v-3h2v3" />
  </svg>
);

export default NestIcon;
